import {
  activeSidePanelsSchema,
  useSidePanel,
  type IActiveSidePanel,
} from "./useSidePanel";
import { AISupportPanel } from "./AISupportPanel/AISupportPanel";
import styles from "./SidePanel.module.scss";
import UserGuideIcon from "@medoma/components/icons/UserGuideIcon";
import { msg } from "@lingui/core/macro";
import { Heading } from "@medoma/components/Heading/Heading";
import { useLingui } from "@lingui/react/macro";
import type { MessageDescriptor } from "@lingui/core";
import { CloseButton } from "@/components/NavigationButtons/NavigationButtons";

const sidePanelComponents: Record<
  IActiveSidePanel,
  {
    Icon: React.ComponentType;
    Title: MessageDescriptor;
    Panel: React.ComponentType;
  }
> = {
  [activeSidePanelsSchema.enum.aiSupportPanel]: {
    Icon: UserGuideIcon,
    Title: msg`Handboken`,
    Panel: AISupportPanel,
  },
};

export const SidePanel = () => {
  const { activeSidePanel, closeSidePanel } = useSidePanel();
  const { t } = useLingui();

  if (!activeSidePanel) {
    return null;
  }

  const activeSidePanelComponents = sidePanelComponents[activeSidePanel];

  if (!activeSidePanelComponents) {
    return null;
  }

  const { Icon, Title, Panel } = activeSidePanelComponents;

  return (
    <div className={styles.sidePanel}>
      <header className={styles.header}>
        <Icon />
        <Heading level="h2" size="h3" weight="medium">
          {t(Title)}
        </Heading>
        <CloseButton close={closeSidePanel} />
      </header>
      <Panel />
    </div>
  );
};
